import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as StrideReviewSelectors from '../selectors/stride-review.selectors';
import * as StrideReviewReducer from '../reducers/stride-review-reducer';

@Injectable()
export class StrideReviewFacade {
  constructor(private readonly store: Store<StrideReviewReducer.State>) {}

  selectSingleStideFilteredKeyPointsItem$ = (recordingId: string) => {
    return this.store.pipe(
      select(
        StrideReviewSelectors.selectSingleStideFilteredKeyPointsItem(
          recordingId
        )
      )
    );
  };

  selectSingleStideReasonDetailItem$ = (recordingId: string) => {
    return this.store.pipe(
      select(
        StrideReviewSelectors.selectSingleStideReasonDetailItem(recordingId)
      )
    );
  };
}
